import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_download",
  "use": "icon_download-usage",
  "viewBox": "0 0 103 103",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 103 103\" id=\"icon_download\"><g fill=\"currentColor\" data-name=\"Download Draftstars\"><path d=\"M49.59 76.15a3.18 3.18 0 0 0 4.81 0L76.81 50.4a3.22 3.22 0 0 0 .51-3.45 3.19 3.19 0 0 0-2.91-1.89H61.6V3.22A3.21 3.21 0 0 0 58.4 0H45.6a3.21 3.21 0 0 0-3.2 3.22v41.84H29.6a3.22 3.22 0 0 0-2.41 5.34z\" /><path d=\"M87.2 70.81v19.32H16.8V70.81H4v25.75a6.42 6.42 0 0 0 6.4 6.44h83.2a6.41 6.41 0 0 0 6.4-6.44V70.81H87.2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol